import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  IconButton,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useMediaQuery,
  Box,
  Typography,
  TextField,
  MenuItem,
  CircularProgress, 
  Grid,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import{
  Save ,
  Cancel, 
  Image as ImageIcon
}from "@mui/icons-material";
import { useTheme } from '@mui/material/styles';
import { useUsuarioTableLogic } from './useTableUser';
import CloseIcon from '@mui/icons-material/Close';
import { useUtil } from '../../../../components/Util/useUtil';



const perfiles = ['admin', 'Socio'];
const tiposDoc = ['DNI', 'Pasaporte', 'CI'];
const estados = ['Activo','Inactivo'];

export const UsuarioTable: React.FC = () => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const {
    FormatDateAMD,
    FormatDate,
  }=useUtil(); 

  const {
    page,
    rowsPerPage,
    selectedUser,
    open,
    paginatedUsers,
    usuarios,
    formData,
    imagePreview,
    loading,
    changePass, 
    inputRef,    
    setChangePass,
    setFormData,
    setImagePreview,
    handleSave,
    handleFieldChange,
    handleChangePage,
    handleChangeRowsPerPage,
    handleRowClick,
    handleClose,
    handleImageChange,
    handleChangePass,
  } = useUsuarioTableLogic(); 

  return (
    <Box sx={{ width: '100%', overflowX: 'auto', mt: 2, pl:2, pr:2}}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell>Apellido</TableCell>              
              <TableCell>Nro Doc</TableCell>
              <TableCell>Fecha Nac.</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell>Avatar</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedUsers.map((user) => (
              <TableRow
                key={user.Id}
                hover
                sx={{ 
                    cursor: 'pointer', backgroundColor: (user.cmp_estado === 'Inactivo')?' #F78181': (user.cmp_estado === 'Activo')?'  #81BEF7':"" }}
                onClick={() => handleRowClick(user)}
              >
                <TableCell>{user.Id}</TableCell>
                <TableCell>{user.cmp_nombre}</TableCell>
                <TableCell>{user.cmp_apellido}</TableCell>                
                <TableCell>{user.cmp_nrodoc}</TableCell>
                <TableCell>
                  {user.cmp_fechanac
                    ? new Date(user.cmp_fechanac).toLocaleDateString()
                    : '-'}
                </TableCell>
                <TableCell>{user.cmp_estado}</TableCell>
                <TableCell>
                  <Avatar
                    src={user.avatar || undefined}
                    alt={`${user.cmp_nombre} ${user.cmp_apellido}`}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={usuarios.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </TableContainer>

      

      <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="edit-socio-dialog"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Editar Socio
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {formData ? (
          <Box
            component="form"
            noValidate
            sx={{ display: 'flex', flexDirection: 'row', gap: 3}}
          >
            <Grid container spacing={1} alignItems="center" flexWrap={'nowrap'}>
              {/* Avatar + Upload */}
              <Grid size={{ xs: 6, sm: 4}} >
                <Box sx={{ textAlign: 'center' }}>
                  <Avatar
                    src={imagePreview || '/default-avatar.png'}
                    sx={{ width: 150, height: 150, mx: 'auto', mb: 2 }}
                  />
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={loading ? <CircularProgress size={18} /> : <ImageIcon />}
                    fullWidth
                  >
                    {loading ? 'Cargando...' : 'Cambiar Imagen'}
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={handleImageChange}
                    />
                  </Button>
                </Box>
              </Grid>

              {/* Form Fields */}
              <Grid size={{ xs: 6, sm: 8}}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, sm: 6}}>
                    <TextField
                      label="Nombre"
                      value={formData.cmp_nombre}
                      onChange={e => handleFieldChange('cmp_nombre', e.target.value)}
                      fullWidth
                    />
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6}}>
                    <TextField
                      label="Apellido"
                      value={formData.cmp_apellido}
                      onChange={e => handleFieldChange('cmp_apellido', e.target.value)}
                      fullWidth
                    />
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6}}>
                    <TextField
                      label="Usuario"
                      value={formData.cmp_usuario}
                      onChange={e => handleFieldChange('cmp_usuario', e.target.value)}
                      fullWidth
                      disabled
                    />
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6}}>
                    <TextField
                      select
                      label="Perfil"
                      value={formData.cmp_perfil}
                      onChange={e => handleFieldChange('cmp_perfil', e.target.value)}
                      fullWidth
                    >
                      {perfiles.map(p => (
                        <MenuItem key={p} value={p}>{p}</MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6}}>
                    <TextField
                      select
                      label="Tipo Doc"
                      value={formData.cmp_tipodoc}
                      onChange={e => handleFieldChange('cmp_tipodoc', e.target.value)}
                      fullWidth
                      disabled
                    >
                      {tiposDoc.map(d => (
                        <MenuItem key={d} value={d}>{d}</MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6}}>
                    <TextField
                      label="Nro Doc"
                      value={formData.cmp_nrodoc}
                      onChange={e => handleFieldChange('cmp_nrodoc', e.target.value)}
                      fullWidth
                      disabled
                    />
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6}}>
                    <TextField
                      label="Fecha Nac."
                      type="date"
                      value={FormatDateAMD(formData.cmp_fechanac)}
                      onChange={e => handleFieldChange('cmp_fechanac', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6}}>
                    <TextField
                      select
                      label="Estado"
                      value={formData.cmp_estado}
                      onChange={e => handleFieldChange('cmp_estado', e.target.value)}
                      fullWidth
                    >
                      {estados.map(s => (
                        <MenuItem key={s} value={s}>{s}</MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6}}>
                    <TextField
                      label="Clave"
                      value={formData.cmp_clave}
                      onChange={e => handleFieldChange('cmp_clave', e.target.value)}
                      type='password'
                      fullWidth
                      disabled={!changePass}
                      ref={inputRef}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6}}>                    
                      <FormControlLabel
                        control={
                          <Checkbox checked={changePass} color='success' onChange={()=>{handleChangePass();}} />
                        }
                        label="Cambiar Clave"
                      />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} startIcon={<Cancel />}>
          Cancelar
        </Button>
        <Button onClick={handleSave} variant="contained" startIcon={<Save />}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

